import { initializeApp, getApps } from 'firebase/app';
import { getAuth, } from 'firebase/auth';
import { getFirestore, } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage, } from 'firebase/storage';
const isBrowser = typeof window !== 'undefined';
let firebaseApp = null;
let auth = null;
let db = null;
let storage = null;
let functions = null;
/**
 * Initialize Firebase with config
 */
export const initializeFirebase = (config) => {
    if (!isBrowser) {
        // Running in Node.js (Cloud Functions)
        // Skip client Firebase initialization
        return {};
    }
    // Check if already initialized
    if (getApps().length > 0) {
        firebaseApp = getApps()[0];
    }
    else {
        firebaseApp = initializeApp(config);
    }
    auth = getAuth(firebaseApp);
    db = getFirestore(firebaseApp);
    storage = getStorage(firebaseApp);
    functions = getFunctions(firebaseApp, 'asia-south1');
    // if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    // Check if not already connected to avoid errors
    // try {
    //   connectFunctionsEmulator(functions, 'localhost', 5001);
    //   console.log(' Connected to Functions Emulator');
    // } catch (error) {
    //   console.log('Functions emulator already connected or unavailable');
    // }
    // try {
    //   connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    //   console.log(' Connected to Auth Emulator');
    // } catch (error) {
    //   console.log('Auth emulator already connected or unavailable');
    // }
    // try {
    //   connectFirestoreEmulator(db, 'localhost', 8080);
    //   console.log(' Connected to Firestore Emulator');
    // } catch (error) {
    //   console.log('Firestore emulator already connected or unavailable');
    // }
    // try {
    //   connectStorageEmulator(storage, 'localhost', 9199);
    //   console.log(' Connected to Storage Emulator');
    // } catch (error) {
    //   console.log('Storage emulator already connected or unavailable');
    // }
    // }
    return firebaseApp;
};
/**
 * Get Firebase Auth instance
 */
export const getFirebaseAuth = () => {
    if (!isBrowser)
        throw new Error("Firebase Auth is not available in Node");
    if (!auth) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return auth;
};
/**
 * Get Firestore instance
 */
export const getFirebaseFirestore = () => {
    if (!isBrowser)
        throw new Error("Firebase Auth is not available in Node");
    if (!db) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return db;
};
/**
 * Get Firebase Storage instance
 */
export const getFirebaseStorage = () => {
    if (!isBrowser)
        throw new Error("Firebase Auth is not available in Node");
    if (!storage) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return storage;
};
/**
 * Get Firebase Functions instance
 */
export const getFirebaseFunctions = () => {
    if (!isBrowser)
        throw new Error("Firebase Auth is not available in Node");
    if (!functions) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return functions;
};
/**
 * Get Firebase App instance
 */
export const getFirebaseApp = () => {
    if (!isBrowser)
        throw new Error("Firebase Auth is not available in Node");
    if (!firebaseApp) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return firebaseApp;
};
